import { setToken, getToken, setLocal, removeToken } from '@/utils/storage.js';
import { getUserInfo } from '@/api/login';
import router from '../../router';
const user = {
  state: {
    token: getToken() || ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
      setToken(token);
    }
  },

  actions: {
    // 获取用户详细信息
    GetUserInfo({ commit, state }, userId) {
      return new Promise((resolve, reject) => {
        getUserInfo(userId).then(result => {
          setLocal('userInfo', result.data);
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },
    JumpPageBasedConditions({ commit }, qwInfo) {
      if (qwInfo.source === 'school') { // 跳转学校端
        window.location.replace(`${window.location.origin}/school.html#/home/app`);
      } else if (qwInfo.source === 'subject') { // 跳转学科管理端
        window.location.replace(`${window.location.origin}/manage.html#/home`);
      } else if (qwInfo.action === 'notice') { // 跳转企微通知
        if (qwInfo.pageType === '1') {
          router.replace({ path: '/guideNotice', query: { planId: qwInfo.pageParamsVal }});
        } else if (qwInfo.pageType === '2') {
          router.replace({ path: '/divisionNotice', query: { planId: qwInfo.pageParamsVal }});
        } else {
          router.replace({ path: '/feedbackReport', query: { planId: qwInfo.pageParamsVal }});
        }
      }
    },
    //  前端登出
    FedLogOut({ commit }) {
      commit('SET_TOKEN', '');
      removeToken();
      setLocal('loginInfo', {});
      setLocal('userInfo', {});
      // setLocal('qwInfo', {});
    }
  }
};

export default user;

